import ShEmpty from './src/main.vue'

ShEmpty.install = Vue => {
  Vue.component(ShEmpty.name, ShEmpty)
}

export default ShEmpty
